import React, { useState } from 'react';
import { Play, X } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

const VideoSection = () => {
  const { language } = useLanguage();
  const [isPlaying, setIsPlaying] = useState(false);

  const content = {
    en: {
      title: "Meet Our Warriors",
      subtitle: "Watch our young girls present TALITHA KOUMI TUG and share their journey of empowerment",
      playButton: "Watch Video"
    },
    fr: {
      title: "Rencontrez Nos Guerrières",
      subtitle: "Regardez nos jeunes filles présenter TALITHA KOUMI TUG et partager leur parcours d'autonomisation",
      playButton: "Regarder la Vidéo"
    }
  };

  const t = content[language] || content.fr;

  return (
    <section className="py-16 md:py-24 bg-gradient-to-br from-[#1D1D1D] to-[#2D5016]">
      <div className="max-w-7xl mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            {t.title}
          </h2>
          <p className="text-lg text-white/80 max-w-2xl mx-auto">
            {t.subtitle}
          </p>
        </div>

        {/* Video Container */}
        <div className="relative max-w-4xl mx-auto">
          {!isPlaying ? (
            <div className="relative aspect-video bg-black rounded-lg overflow-hidden shadow-2xl">
              {/* Video Thumbnail/Preview */}
              <video
                className="w-full h-full object-cover"
                muted
                playsInline
                poster="https://customer-assets.emergentagent.com/job_talitha-koumi/artifacts/u4ct7pnl_file_00000000ffa4722f9243b515e4a1db6e.png"
              >
                <source 
                  src="https://customer-assets.emergentagent.com/job_talitha-koumi/artifacts/40h4ropw_VID_20260121_104506_190.mp4" 
                  type="video/mp4" 
                />
              </video>
              
              {/* Play Button Overlay */}
              <div className="absolute inset-0 bg-black/40 flex items-center justify-center">
                <button
                  onClick={() => setIsPlaying(true)}
                  className="group flex flex-col items-center gap-4"
                >
                  <div className="w-20 h-20 md:w-24 md:h-24 bg-[#CD0000] rounded-full flex items-center justify-center group-hover:bg-[#c91560] transition-all group-hover:scale-110 shadow-lg">
                    <Play className="w-10 h-10 md:w-12 md:h-12 text-white ml-1" fill="white" />
                  </div>
                  <span className="text-white font-bold text-lg">{t.playButton}</span>
                </button>
              </div>
            </div>
          ) : (
            <div className="relative aspect-video bg-black rounded-lg overflow-hidden shadow-2xl">
              <video
                className="w-full h-full"
                controls
                autoPlay
                playsInline
              >
                <source 
                  src="https://customer-assets.emergentagent.com/job_talitha-koumi/artifacts/40h4ropw_VID_20260121_104506_190.mp4" 
                  type="video/mp4" 
                />
                Your browser does not support the video tag.
              </video>
              
              {/* Close Button */}
              <button
                onClick={() => setIsPlaying(false)}
                className="absolute top-4 right-4 w-10 h-10 bg-black/50 rounded-full flex items-center justify-center hover:bg-black/70 transition-colors"
              >
                <X className="w-6 h-6 text-white" />
              </button>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default VideoSection;
